// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══ SPINNER OVERLAY ═════════════════════════════════════════════════════ */
.spinner-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.6);
    z-index: 9999;
}

/* Host fills the available space in app-body */
:host {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
}

/* Main element fills host */
main.container-fluid {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
    height: 100%;
}

/* ═══ STATUS DOT ═══════════════════════════════════════════════════════════ */
.status-dot {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    margin-right: 6px;
    flex-shrink: 0;
    vertical-align: middle;
}

/* ═══ TOOLS TOOLBAR ════════════════════════════════════════════════════════ */

.tools-menu-btn {
    display: inline-flex;
    align-items: center;
    background: #fff;
    border: 1px solid #aaa;
    border-radius: 3px;
    padding: 4px 10px 4px 12px;
    font-size: 0.875rem;
    font-weight: 600;
    cursor: pointer;
    gap: 2px;
    line-height: 1.5;
}

.tools-menu-arrow {
    font-size: 18px;
    width: 18px;
    height: 18px;
    line-height: 18px;
    vertical-align: middle;
}

::ng-deep .tools-panel-menu .mat-mdc-menu-item {
    font-size: 0.875rem;
    height: 36px;
    min-height: 36px;
    border-bottom: 1px solid #f0f0f0;
}

/* ═══ WRAPPER ══════════════════════════════════════════════════════════════ */
.dashboard-wrapper {
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
}

.outlet-content-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
}

/* Make app-data-grid expand naturally inside the scrollable .dashboard-main */
.dashboard-main ::ng-deep app-data-grid {
    display: block;
    width: 100%;
}

/* Reduce data-grid header row height for projects dashboard only */
.dashboard-main ::ng-deep app-data-grid .data-grid-table .mat-mdc-header-row {
    height: 36px;
    min-height: 36px;
}

.dashboard-main ::ng-deep app-data-grid .data-grid-table .mat-mdc-header-row .mat-mdc-header-cell {
    padding-top: 0;
    padding-bottom: 0;
}

/* ═══ SIDEBAR ══════════════════════════════════════════════════════════════ */
.sidebar-panel {
    width: 360px;
    min-width: 360px;
    height: 100%;
    background: #ffffff;
    border-right: 1px solid #dbdcdd;
    display: flex;
    flex-direction: column;
    padding: 12px 10px;
    overflow-y: auto;
    overflow-x: hidden;
    transition: width 0.25s ease, min-width 0.25s ease, padding 0.25s ease;
}

.sidebar-panel.sidebar-collapsed {
    width: 36px;
    min-width: 36px;
    padding: 8px 2px;
    overflow: hidden;
}

.sidebar-toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid #dbdcdd;
    border-radius: 4px;
    cursor: pointer;
    padding: 2px;
    margin-bottom: 8px;
    align-self: flex-end;
    color: #0066b2;
    flex-shrink: 0;
    transition: background 0.15s;
}

.sidebar-toggle-btn:hover {
    background: #e8f0fb;
}

.sidebar-panel.sidebar-collapsed .sidebar-toggle-btn {
    align-self: center;
    margin-bottom: 0;
}

.sidebar-content {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
}

.sidebar-year-label {
    font-size: 0.90rem;
    font-weight: 600;
    white-space: nowrap;
    margin-right: 5px;
}

.sidebar-action-buttons {
    gap: 8px;
}

/* ── Tree ─────────────────────────────────────────────────────────────────── */
.sidebar-tree {
    flex: 1;
    overflow-y: auto;
    font-size: 0.875rem;
}

.sidebar-root-node {
    padding: 6px 8px;
    cursor: pointer;
    font-weight: 600;
    border-radius: 2px;
    -webkit-user-select: none;
            user-select: none;
    display: flex;
    align-items: center;
}

.sidebar-root-node.selected,
.sidebar-root-node:hover,
.tree-section-header.selected,
.tree-leaf.selected,
.tree-sbu-header.selected,
.tree-well-header.selected {
    background-color: #0066b2;
    color: #ffffff;
}

/* Section level (All SBUs / R&D / Trash) */
.tree-section-header {
    padding: 5px 8px 5px 8px;
    cursor: pointer;
    font-weight: 500;
    -webkit-user-select: none;
            user-select: none;
    color: #212529;
    border-radius: 2px;
    display: flex;
    align-items: center;
}

.tree-section-header:hover,
.tree-leaf:hover,
.tree-sbu-header:hover,
.tree-well-header:hover {
    background-color: #e8f0fb;
    color: #0066b2;
}

/* Project leaf directly under a section (R&D / Trash) */
.tree-section-leaf {
    padding-left: 20px !important;
}


/* Tree leaf items */
.tree-leaf {
    padding: 4px 8px 4px 16px;
    cursor: pointer;
    border-radius: 2px;
    color: #212529;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}



/* SBU level (inside All SBUs section) */
.tree-sbu-header {
    padding: 4px 8px 4px 14px;
    cursor: pointer;
    font-weight: 500;
    -webkit-user-select: none;
            user-select: none;
    color: #212529;
    border-radius: 2px;
    display: flex;
    align-items: center;
}



/* Well level (inside SBU) */
.tree-well-header {
    padding: 4px 8px 4px 24px;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
    color: #212529;
    border-radius: 2px;
    display: flex;
    align-items: center;
}



/* Project leaf inside a well */
.tree-project-leaf {
    padding-left: 34px !important;
}

.tree-arrow {
    font-size: 20px !important;
    width: 20px !important;
    height: 20px !important;
    line-height: 20px !important;
    margin-left: auto;
    margin-right: 2px;
    flex-shrink: 0;
    cursor: pointer;
}

/* ═══ MAIN CONTENT ══════════════════════════════════════════════════════════ */
.dashboard-main {
    height: 100%;
    padding: 16px 8px;
    background: #ffffff;
    overflow-y: auto;
    overflow-x: hidden;
}

.dashboard-main.details-view {
    overflow: auto;
}

.dashboard-main ::ng-deep app-project-details {
    display: block;
    width: 100%;
    min-width: 0;
}

.dashboard-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.dashboard-title {
    font-size: 1.2rem;
    margin: 0;
}

.view-links {
    display: flex;
    gap: 16px;
}

.trash-action-icon {
    cursor: pointer;
    font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/projects-dashboard/projects-dashboard.component.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,aAAa;AACjB;;AAEA,+CAA+C;AAC/C;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,YAAY;AAChB;;AAEA,+EAA+E;AAC/E;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;AAC1B;;AAEA,+EAA+E;;AAE/E;IACI,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA,+EAA+E;AAC/E;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,8EAA8E;AAC9E;IACI,cAAc;IACd,WAAW;AACf;;AAEA,mEAAmE;AACnE;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,+EAA+E;AAC/E;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sEAAsE;AAC1E;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;IACd,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,QAAQ;AACZ;;AAEA,gFAAgF;AAChF;IACI,OAAO;IACP,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;;;IAMI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,2CAA2C;AAC3C;IACI,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;;;;IAII,yBAAyB;IACzB,cAAc;AAClB;;AAEA,wDAAwD;AACxD;IACI,6BAA6B;AACjC;;;AAGA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;;;AAIA,wCAAwC;AACxC;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;;;AAIA,4BAA4B;AAC5B;IACI,yBAAyB;IACzB,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;;;AAIA,+BAA+B;AAC/B;IACI,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,uBAAuB;IACvB,4BAA4B;IAC5B,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA,gFAAgF;AAChF;IACI,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;AACnB","sourcesContent":["/* ═══ SPINNER OVERLAY ═════════════════════════════════════════════════════ */\n.spinner-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 255, 255, 0.6);\n    z-index: 9999;\n}\n\n/* Host fills the available space in app-body */\n:host {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    min-height: 0;\n    overflow: hidden;\n}\n\n/* Main element fills host */\nmain.container-fluid {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    min-height: 0;\n    overflow: hidden;\n    height: 100%;\n}\n\n/* ═══ STATUS DOT ═══════════════════════════════════════════════════════════ */\n.status-dot {\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    margin-right: 6px;\n    flex-shrink: 0;\n    vertical-align: middle;\n}\n\n/* ═══ TOOLS TOOLBAR ════════════════════════════════════════════════════════ */\n\n.tools-menu-btn {\n    display: inline-flex;\n    align-items: center;\n    background: #fff;\n    border: 1px solid #aaa;\n    border-radius: 3px;\n    padding: 4px 10px 4px 12px;\n    font-size: 0.875rem;\n    font-weight: 600;\n    cursor: pointer;\n    gap: 2px;\n    line-height: 1.5;\n}\n\n.tools-menu-arrow {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n    line-height: 18px;\n    vertical-align: middle;\n}\n\n::ng-deep .tools-panel-menu .mat-mdc-menu-item {\n    font-size: 0.875rem;\n    height: 36px;\n    min-height: 36px;\n    border-bottom: 1px solid #f0f0f0;\n}\n\n/* ═══ WRAPPER ══════════════════════════════════════════════════════════════ */\n.dashboard-wrapper {\n    flex: 1 1 0;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.outlet-content-wrapper {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    min-height: 0;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n/* Make app-data-grid expand naturally inside the scrollable .dashboard-main */\n.dashboard-main ::ng-deep app-data-grid {\n    display: block;\n    width: 100%;\n}\n\n/* Reduce data-grid header row height for projects dashboard only */\n.dashboard-main ::ng-deep app-data-grid .data-grid-table .mat-mdc-header-row {\n    height: 36px;\n    min-height: 36px;\n}\n\n.dashboard-main ::ng-deep app-data-grid .data-grid-table .mat-mdc-header-row .mat-mdc-header-cell {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n\n/* ═══ SIDEBAR ══════════════════════════════════════════════════════════════ */\n.sidebar-panel {\n    width: 360px;\n    min-width: 360px;\n    height: 100%;\n    background: #ffffff;\n    border-right: 1px solid #dbdcdd;\n    display: flex;\n    flex-direction: column;\n    padding: 12px 10px;\n    overflow-y: auto;\n    overflow-x: hidden;\n    transition: width 0.25s ease, min-width 0.25s ease, padding 0.25s ease;\n}\n\n.sidebar-panel.sidebar-collapsed {\n    width: 36px;\n    min-width: 36px;\n    padding: 8px 2px;\n    overflow: hidden;\n}\n\n.sidebar-toggle-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 1px solid #dbdcdd;\n    border-radius: 4px;\n    cursor: pointer;\n    padding: 2px;\n    margin-bottom: 8px;\n    align-self: flex-end;\n    color: #0066b2;\n    flex-shrink: 0;\n    transition: background 0.15s;\n}\n\n.sidebar-toggle-btn:hover {\n    background: #e8f0fb;\n}\n\n.sidebar-panel.sidebar-collapsed .sidebar-toggle-btn {\n    align-self: center;\n    margin-bottom: 0;\n}\n\n.sidebar-content {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 0;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.sidebar-year-label {\n    font-size: 0.90rem;\n    font-weight: 600;\n    white-space: nowrap;\n    margin-right: 5px;\n}\n\n.sidebar-action-buttons {\n    gap: 8px;\n}\n\n/* ── Tree ─────────────────────────────────────────────────────────────────── */\n.sidebar-tree {\n    flex: 1;\n    overflow-y: auto;\n    font-size: 0.875rem;\n}\n\n.sidebar-root-node {\n    padding: 6px 8px;\n    cursor: pointer;\n    font-weight: 600;\n    border-radius: 2px;\n    user-select: none;\n    display: flex;\n    align-items: center;\n}\n\n.sidebar-root-node.selected,\n.sidebar-root-node:hover,\n.tree-section-header.selected,\n.tree-leaf.selected,\n.tree-sbu-header.selected,\n.tree-well-header.selected {\n    background-color: #0066b2;\n    color: #ffffff;\n}\n\n/* Section level (All SBUs / R&D / Trash) */\n.tree-section-header {\n    padding: 5px 8px 5px 8px;\n    cursor: pointer;\n    font-weight: 500;\n    user-select: none;\n    color: #212529;\n    border-radius: 2px;\n    display: flex;\n    align-items: center;\n}\n\n.tree-section-header:hover,\n.tree-leaf:hover,\n.tree-sbu-header:hover,\n.tree-well-header:hover {\n    background-color: #e8f0fb;\n    color: #0066b2;\n}\n\n/* Project leaf directly under a section (R&D / Trash) */\n.tree-section-leaf {\n    padding-left: 20px !important;\n}\n\n\n/* Tree leaf items */\n.tree-leaf {\n    padding: 4px 8px 4px 16px;\n    cursor: pointer;\n    border-radius: 2px;\n    color: #212529;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n\n\n/* SBU level (inside All SBUs section) */\n.tree-sbu-header {\n    padding: 4px 8px 4px 14px;\n    cursor: pointer;\n    font-weight: 500;\n    user-select: none;\n    color: #212529;\n    border-radius: 2px;\n    display: flex;\n    align-items: center;\n}\n\n\n\n/* Well level (inside SBU) */\n.tree-well-header {\n    padding: 4px 8px 4px 24px;\n    cursor: pointer;\n    user-select: none;\n    color: #212529;\n    border-radius: 2px;\n    display: flex;\n    align-items: center;\n}\n\n\n\n/* Project leaf inside a well */\n.tree-project-leaf {\n    padding-left: 34px !important;\n}\n\n.tree-arrow {\n    font-size: 20px !important;\n    width: 20px !important;\n    height: 20px !important;\n    line-height: 20px !important;\n    margin-left: auto;\n    margin-right: 2px;\n    flex-shrink: 0;\n    cursor: pointer;\n}\n\n/* ═══ MAIN CONTENT ══════════════════════════════════════════════════════════ */\n.dashboard-main {\n    height: 100%;\n    padding: 16px 8px;\n    background: #ffffff;\n    overflow-y: auto;\n    overflow-x: hidden;\n}\n\n.dashboard-main.details-view {\n    overflow: auto;\n}\n\n.dashboard-main ::ng-deep app-project-details {\n    display: block;\n    width: 100%;\n    min-width: 0;\n}\n\n.dashboard-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n}\n\n.dashboard-title {\n    font-size: 1.2rem;\n    margin: 0;\n}\n\n.view-links {\n    display: flex;\n    gap: 16px;\n}\n\n.trash-action-icon {\n    cursor: pointer;\n    font-size: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
